export const TASK_STATUSES = ['DONE', 'PENDING', 'PAST_DUE'] as const;

export type TaskStatus = typeof TASK_STATUSES[number];
